export const colorOptions = [
  {
    label: 'orange',
    color: '#FCA92D',
  },
  {
    label: 'blue',
    color: '#16ABEB',
  },
  {
    label: 'green',
    color: '#02C19F',
  },
  {
    label: 'red',
    color: '#FB4A4A',
  },
  {
    label: 'gray',
    color: '#717E94',
  },
  {
    label: 'black',
    color: '#263044',
  },
] as const;
